export default __webpack_public_path__ + "static/media/sendDarkMode.a6cfa14a.svg";